import React from "react";
import { ApiWrapped } from "./ApiWrapped";
import { Tabs, Tab } from "@blueprintjs/core";
import Raw from "./Raw";
import LocationFunctions from "./LocationFunctions";
import LocationEvents from "./LocationEvents";
import LocationUsers from "./LocationUsers";
import { useRouteMatch, useHistory } from "react-router-dom";

export default function Location({ token, device }) {
  const match = useRouteMatch("/web/session/:x/:y/:tab?");
  const history = useHistory();

  const selectedTabId =
    (match && match.params && match.params.tab) || "functions";

  console.log('selected tab', selectedTabId)

  return (
    <ApiWrapped
      token={token}
      endpoint={`/devices/${device.deviceUuid}`}
      renderCallback={({ state, setState }) => {
        return (
          <>
            <Raw json={state} />
            <p>
              <strong>Name:</strong> {device.name}
            </p>
            <p>
              <strong>Status:</strong> {state.status}
            </p>
            <p>
              <strong>Alarm State:</strong> {state.alarmState}
            </p>
            <p>
              <strong>Can View Event History:</strong> {state.viewEventHistory}
            </p>
            <Tabs
              selectedTabId={selectedTabId}
              onChange={(newTab) => {
                history.push(
                  `/web/session/${match.params.x}/${match.params.y}/${newTab}`
                );
              }}
              renderActiveTabPanelOnly
            >
              <Tab
                id="functions"
                title="Functions"
                panel={
                  <LocationFunctions
                    token={token}
                    dashboard={state.dashboard}
                    device={device}
                    nodes={state.deviceNodes}
                  />
                }
              />
              <Tab
                id="events"
                title="Events"
                panel={
                  <LocationEvents
                    token={token}
                    device={device}
                  />
                }
              />
              <Tab
                id="users"
                title="Users"
                panel={<LocationUsers token={token} device={device} />}
              />
            </Tabs>
          </>
        );
      }}
    />
  );
}
